import React, { useState } from 'react';
import { Box, Typography, Tooltip } from '@mui/material';
import { ContentCopyIcon } from 'icons/materialIcons';
import PropTypes from 'prop-types';

const ContactEmailCell = ({ email, onCopyEmail, contactId }) => {
  const [isHovered, setIsHovered] = useState(false);
  const [isCopied, setIsCopied] = useState(false);

  const handleCopyEmail = async (e) => {
    try {
      await onCopyEmail(e, email, contactId);
      setIsCopied(true);
      setTimeout(() => setIsCopied(false), 1500);
    } catch (err) {
    }
  };

  return (
    <Box
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 1,
        cursor: 'pointer',
        '&:hover': {
          '& .copy-icon': {
            visibility: 'visible',
          },
        },
      }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <Typography variant="body2" color="text.secondary">
        {email}
      </Typography>
      <Tooltip title={isCopied ? 'Copied!' : 'Copy email'} placement="top">
        <ContentCopyIcon
          className="copy-icon"
          onClick={handleCopyEmail}
          sx={{
            fontSize: 14,
            color: '#828282',
            visibility: isHovered ? 'visible' : 'hidden',
            ml: 0.5,
          }}
          data-copy-button
        />
      </Tooltip>
    </Box>
  );
};

ContactEmailCell.propTypes = {
  email: PropTypes.string.isRequired,
  onCopyEmail: PropTypes.func.isRequired,
  contactId: PropTypes.string.isRequired,
};

export default ContactEmailCell;